<div class="reviews-outer" [formGroup]="activitiesForm">
  <h2 class="trinidad-bold">What activities are available at this location?</h2>
  <p class="wizard-paragraph _12px">
    Let us know of any activities that are available at this location. Please be as accurate as possible.
  </p>
  <div class="div-block-72">
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="biking"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Biking</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="biking"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="boating"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Boating</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="boating"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="fishing"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Fishing</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="fishing"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="golf"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Golf</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="golf"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="hiking"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Hiking</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="hiking"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="horseback"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Horseback Riding</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="horseback"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="hunting"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Hunting</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="hunting"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="kayaking"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Kayaking</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="kayaking"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="motorSports"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Motor Sports</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="motorSports"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="ohv"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">OHV Trails</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="ohv"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="rafting"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Rafting</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="rafting"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="rockClimbing"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Rock Climbing</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="rockClimbing"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="snowSports"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Snow Sports</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="snowSports"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="surfing"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Surfing</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="surfing"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="swimming"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Swimming</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="swimming"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="waterSports"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Water Sports</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="waterSports"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="wildlifeWatching"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Wildlife Watching</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="wildlifeWatching"></curbnturf-rating-availability-toggle>
    </div>
    <div class="boondocking-wrapper">
      <div class="category-inner">
        <div class="cnt-button-icon">
          <div class="html-embed w-embed">
            <curbnturf-site-svgs type="windSports"></curbnturf-site-svgs>
          </div>
        </div>
        <div class="boondocking-copy">Wind Sports</div>
      </div>
      <curbnturf-rating-availability-toggle formControlName="windSports"></curbnturf-rating-availability-toggle>
    </div>
  </div>
  <div class="button-wrapper">
    <a role="button" class="button trinidad center w-button" (click)="onContinue()">Continue</a>
  </div>
  <div class="skip" *ngIf="!appContext">
    <a role="button" (click)="onSkip()">Skip</a>
  </div>
</div>
